import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { unregister } from './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.css';
import './theme.css';
import 'font-awesome/css/font-awesome.css'

ReactDOM.render(<App />, document.getElementById('root'))
unregister()



// WEBPACK FOOTER //
// ./src/index.js